import {
  AnswerResultEnum,
  CompletionResultStatusEnum,
  QuestionTypeEnum,
  UserQuizStatusEnum,
} from '@/swagger/constants/quiz-enums';

export const MOCK_RESPONSE_POST_QUIZ_START = {
  id: 'string',
  quizId: 'string',
  userId: 'string',
  orgId: 'string',
  createdAt: '2025-12-01T15:55:15.937Z',
  updateAt: '2025-12-01T15:55:15.937Z',
  isCompleted: true,
  submittedSteps: [
    {
      responseValue: [2],
      questionId: 1,
      question: {
        id: 1,
        type: QuestionTypeEnum.SINGLE_CHOICE,
        text: "106'44}{}39}p{ 45-3657-1",
        maxSelections: 1,
        options: [
          {
            id: 1, // TODO fix with id 0
            text: 'string 0',
          },
          {
            id: 2,
            text: 'string 1',
          },
        ],
        enrichment: '-34}107L-',
      },
      stepNumber: 1,
      answerResult: AnswerResultEnum.CORRECT,
    },
  ],
  nextQuestion: {
    question: {
      id: 3,
      type: QuestionTypeEnum.SINGLE_CHOICE,
      text: "LLL4{'}{49p1365594''4{7' 8'{'8} 445L5'416p1'41 4}0",
      maxSelections: 1,
      options: [
        {
          id: 5, // TODO fix with id 0
          text: 'string 5',
        },
        {
          id: 6,
          text: 'string 6',
        },
      ],
    },
    stepNumber: 2,
    totalSteps: 3,
  },
};

export const MOCK_RESPONSE_POST_QUIZ_BY_ID_NEXT = {
  answerResult: AnswerResultEnum.CORRECT,
  enrichment: 'string',
  nextQuestion: {
    question: {
      id: 2,
      type: QuestionTypeEnum.SINGLE_CHOICE,
      text: '794p 45L12p{581931675454{9L0782622-29297p3}',
      maxSelections: 1,
      options: [
        {
          id: 3,
          text: 'string 3',
        },
        {
          id: 4,
          text: 'string 4',
        },
      ],
    },
    stepNumber: 3,
    totalSteps: 3,
  },
};

export const MOCK_RESPONSE_GET_QUIZ_BY_ID_RESULT = {
  corrects: 0.1,
  totals: 0,
  percentage: 100,
  peerScore: 100,
  peerCount: 0,
  status: CompletionResultStatusEnum.FULL_SUCCEEDED,
};

export const MOCK_RESPONSE_GET_QUIZ_BY_ID = {
  id: 'string',
  name: 'string',
  createdAt: '2025-12-09T12:46:31.873Z',
  updatedAt: '2025-12-09T12:46:31.873Z',
  credits: 0,
  summary: 'string',
  description: 'string',
  isActive: true,
  questionsPickLimit: 0,
  durationInMillis: 0,
  lastRevision: 0,
  userStatus: UserQuizStatusEnum.NOT_STARTED,
  usersCount: 0,
};
